import "core-js/modules/es6.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { createRmMenu, deleteRmMenu as _deleteRmMenu, deleteRmMenuByIds, findRmMenu, getRmMenuTreeList, updateRmMenu } from "@/api/rm_menu"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/data";
import infoList from "@/components/mixins/infoList";
import { getAllRmToolList } from "@/api/rm_tool";
import { getAllRmParamlList } from "@/api/rm_param";
import { getDict } from "@/utils/dictionary";
import { uploadImage } from "@/api/upload";
export default {
  name: "RmMenu",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getRmMenuTreeList,
      dialogFormVisible: false,
      dialogTitle: "",
      upload_url: uploadImage,
      visible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      type: "",
      imageUrl: "",
      fileList: [],
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        code: null,
        reportName: null,
        reportNameEn: null,
        reportNameZh: null,
        reportIcon: null,
        reportUrl: null,
        reportStatus: null,
        reportOrder: 0,
        reportParentId: 0,
        reportType: null,
        reportAttribute: null,
        reportReportTool: null,
        reportRemark: null,
        isDelete: null,
        createTime: null,
        createUser: null,
        updateTime: null,
        updateUser: null,
        designType: null,
        showfront: null,
        menuDesc: null,
        tabType: 1
      },
      statusOptions: [{
        value: '1',
        label: this.$t('common.enable')
      }, {
        value: '0',
        label: this.$t('common.disable')
      }],
      singleShowOptions: [{
        value: 1,
        label: 'yes'
      }, {
        value: 0,
        label: 'no'
      }],
      showfrontOptions: [{
        value: '1',
        label: this.$t('common.enable')
      }, {
        value: '0',
        label: this.$t('common.disable')
      }],
      reportTypeOptions: [],
      toolOptions: [],
      paramOptions: [],
      rmmenuOption: [{
        ID: "0",
        title: "目录"
      }],
      isEdit: false
    };
  },
  methods: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? this.$t('common.yes') : this.$t('common.no');
      } else {
        return "";
      }
    },
    statusFilter: function statusFilter(value) {
      //console.log(value);
      var target = this.statusOptions.filter(function (item) {
        return item.value === value.reportStatus;
      })[0];
      // return target && `${target.label}(${target.value})`
      //console.log(target);
      return target && "".concat(target.label);
    },
    tabFilter: function tabFilter(value) {
      //console.log(value);
      var target = this.singleShowOptions.filter(function (item) {
        return item.value === value.tabType;
      })[0];
      // return target && `${target.label}(${target.value})`
      //console.log(target);
      return target && "".concat(target.label);
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    UploadImage: function () {
      var _UploadImage = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(param) {
        var formData, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = new FormData();
              formData.append('file', param.file);
              console.log(formData);
              _context.next = 1;
              return uploadImage(formData);
            case 1:
              res = _context.sent;
              console.log(res);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function UploadImage(_x) {
        return _UploadImage.apply(this, arguments);
      }
      return UploadImage;
    }(),
    upload: function () {
      var _upload = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
        var formData, res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              formData = new FormData();
              formData.append('file', file.file);
              _context2.next = 1;
              return this.$axios.post(process.env.VUE_APP_BASE_API + "/file/uploadFile", formData);
            case 1:
              res = _context2.sent;
              //var res = await uploadImage(formData);
              // console.log(res.data);
              if (res != null && res.data.code == 0) {
                this.formData.reportIcon = res.data.data;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function upload(_x2) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }(),
    beforeUpload: function beforeUpload(file) {
      var isAllow = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isAllow) {
        this.$q.notify({
          message: this.$t('report_management.image_format'),
          color: 'negative'
        });
      }
      if (!isLt5M) {
        this.$q.notify({
          message: this.$t('report_management.image_size'),
          color: 'negative'
        });
      }
      return isAllow && isLt5M;
    },
    handleRemove: function handleRemove(file) {
      var index = this.fileList.findIndex(function (v) {
        return v.uid === file.uid;
      });
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addMenu: function addMenu(id) {
      this.isEdit = false;
      this.dialogTitle = this.$t('common.add');
      this.formData.reportParentId = String(id);
      this.getRmTool();
      this.getRmAllParam();
      this.setOptions();
      this.dialogFormVisible = true;
    },
    setOptions: function setOptions() {
      this.rmmenuOption = [{
        ID: "0",
        title: this.$t('report_management.dir')
      }];
      this.setMenuOptions(this.tableData, this.rmmenuOption, false);
    },
    setMenuOptions: function setMenuOptions(menuData, optionsData, disabled) {
      var _this = this;
      menuData && menuData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            title: item.reportNameZh,
            ID: String(item.ID),
            disabled: disabled || item.ID == _this.formData.ID,
            children: []
          };
          _this.setMenuOptions(item.children, option.children, disabled || item.ID == _this.formData.ID);
          optionsData.push(option);
        } else {
          var _option = {
            title: item.reportNameZh,
            ID: String(item.ID),
            disabled: disabled || item.ID == _this.formData.ID
          };
          optionsData.push(_option);
        }
      });
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var ids, res;
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      ids = [];
                      _this2.multipleSelection && _this2.multipleSelection.map(function (item) {
                        ids.push(item.ID);
                      });
                      _context3.next = 1;
                      return deleteRmMenuByIds({
                        ids: ids
                      });
                    case 1:
                      res = _context3.sent;
                      if (res.code == 0) {
                        _this2.$message({
                          type: 'success',
                          message: _this2.$t("common.success")
                        });
                        _this2.deleteVisible = false;
                        _this2.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }))).catch(function () {
                _this2.$message({
                  type: "info",
                  message: _this2.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function onDelete() {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    updateRmMenu: function () {
      var _updateRmMenu = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return findRmMenu({
                ID: row.ID
              });
            case 1:
              res = _context5.sent;
              this.type = "update";
              this.dialogTitle = this.$t('common.edit');
              if (res.code == 0) {
                this.formData = res.data.rermMenu;
                this.isEdit = true;
                this.getRmTool();
                this.getRmAllParam();
                this.setOptions();
                this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateRmMenu(_x3) {
        return _updateRmMenu.apply(this, arguments);
      }
      return updateRmMenu;
    }(),
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.fileList = [];
      this.formData = {
        code: null,
        reportName: null,
        reportNameEn: null,
        reportNameZh: null,
        reportIcon: null,
        reportUrl: null,
        reportStatus: null,
        reportOrder: 0,
        reportParentId: 0,
        reportType: null,
        reportAttribute: null,
        reportReportTool: null,
        reportRemark: null,
        isDelete: null,
        createTime: null,
        createUser: null,
        updateTime: null,
        updateUser: null,
        designType: null,
        showfront: null,
        menuDesc: null,
        isTab: 1
      };
    },
    deleteRmMenu: function () {
      var _deleteRmMenu2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(row) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var res;
                return regeneratorRuntime.wrap(function (_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _this3.visible = false;
                      _context6.next = 1;
                      return _deleteRmMenu({
                        ID: row.ID
                      });
                    case 1:
                      res = _context6.sent;
                      if (res.code == 0) {
                        _this3.$message({
                          type: "success",
                          message: _this3.$t('common.success')
                        });
                        _this3.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }))).catch(function () {
                _this3.$message({
                  type: "info",
                  message: _this3.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteRmMenu(_x4) {
        return _deleteRmMenu2.apply(this, arguments);
      }
      return deleteRmMenu;
    }(),
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              console.log(this.type);
              _t = this.type;
              _context8.next = _t === "create" ? 1 : _t === "update" ? 3 : 5;
              break;
            case 1:
              _context8.next = 2;
              return createRmMenu(this.formData);
            case 2:
              res = _context8.sent;
              return _context8.abrupt("continue", 7);
            case 3:
              _context8.next = 4;
              return updateRmMenu(this.formData);
            case 4:
              res = _context8.sent;
              return _context8.abrupt("continue", 7);
            case 5:
              _context8.next = 6;
              return createRmMenu(this.formData);
            case 6:
              res = _context8.sent;
              return _context8.abrupt("continue", 7);
            case 7:
              if (!(res.code == 0)) {
                _context8.next = 8;
                break;
              }
              this.$message({
                type: "success",
                message: this.$t('common.add')
              });
              this.closeDialog();
              _context8.next = 8;
              return this.getTableData();
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    openDialog: function openDialog(type) {
      switch (type) {
        case 'create':
          this.dialogTitle = this.$t('common.add');
          this.dialogFormVisible = true;
          break;
        case 'edit':
          this.dialogTitle = this.$t('common.eidt');
          this.dialogFormVisible = true;
          break;
        default:
          break;
      }
      this.type = type;
      this.getRmTool();
      this.getRmAllParam();
      this.dialogFormVisible = true;
    },
    getRmTool: function () {
      var _getRmTool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 1;
              return getAllRmToolList({});
            case 1:
              res = _context9.sent;
              if (res.code == 0) {
                this.toolOptions = res.data.rmtools;
              }
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getRmTool() {
        return _getRmTool.apply(this, arguments);
      }
      return getRmTool;
    }(),
    getRmAllParam: function () {
      var _getRmAllParam = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return getAllRmParamlList({});
            case 1:
              res = _context0.sent;
              //console.log(res);
              if (res.code == 0) {
                this.paramOptions = res.data.rmparams;
              }
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function getRmAllParam() {
        return _getRmAllParam.apply(this, arguments);
      }
      return getRmAllParam;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
      var res;
      return regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            _context1.next = 1;
            return this.getTableData();
          case 1:
            _context1.next = 2;
            return getDict("reportTypeOptions");
          case 2:
            res = _context1.sent;
            this.reportTypeOptions = res;
            _context1.next = 3;
            return this.getRmTool();
          case 3:
          case "end":
            return _context1.stop();
        }
      }, _callee1, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};